import { IManagingLinuxServiceInstance } from '../../api/models';
import { AppEnvironment } from '../../constants/AppEnvironment';
import { LinuxServiceLoadState } from '../../constants/LinuxServiceLoadState';
import { IStyledText, StyledText } from '../UIExtentions/Text';

function GetLoadStateTypeProps(loadState: string, environment: AppEnvironment): IStyledText {
    const warningClass = environment === AppEnvironment.Production ? 'text-orange' : null;
    switch (loadState) {
        case LinuxServiceLoadState.Loaded:
            return {
                text: 'Loaded',
                className: environment === AppEnvironment.Production ? 'text-success' : null,
            };
        case LinuxServiceLoadState.Error:
            return {
                text: 'Error',
                className: warningClass,
            };
        case LinuxServiceLoadState.NotFound:
            return {
                text: 'Not Found',
                className: warningClass,
            };
        case LinuxServiceLoadState.BadSetting:
            return {
                text: 'Bad Setting',
                className: warningClass,
            };
        case LinuxServiceLoadState.Stub:
            return {
                text: 'Stub',
                className: warningClass,
            };
        case LinuxServiceLoadState.Merged:
            return {
                text: 'Merged',
                className: warningClass,
            };
        case LinuxServiceLoadState.Masked:
            return {
                text: 'Masked',
                className: warningClass,
            };
        default:
            return {
                text: loadState,
            };
    }
}

export default function LinuxServiceLoadStateText(serverApp: IManagingLinuxServiceInstance) {
    const loadStateProps = GetLoadStateTypeProps(serverApp.loadState, serverApp.environment as AppEnvironment);

    return <StyledText {...loadStateProps} />;
}
